import React, { useState } from 'react';
import { signInWithEmail, signUpWithEmail, resetPassword } from '../firebase';
import './AuthForm.css';

const AuthForm = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setMessage('');

    try {
      let result;
      if (isSignUp) {
        result = await signUpWithEmail(email, password);
      } else {
        result = await signInWithEmail(email, password);
      }

      if (result.error) {
        setError(result.error);
      } else {
        setMessage(isSignUp ? 'Account created successfully!' : 'Signed in successfully!');
        setEmail('');
        setPassword('');
      }
    } catch (err) {
      setError('An unexpected error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordReset = async () => {
    if (!email) {
      setError('Please enter your email address first');
      return;
    }

    setLoading(true);
    setError('');
    setMessage('');

    const result = await resetPassword(email);
    if (result.error) {
      setError(result.error);
    } else {
      setMessage('Password reset email sent!');
    }
    setLoading(false);
  };

  return (
    <div className="auth-form-container">
      <form onSubmit={handleSubmit} className="auth-form">
        <h2>{isSignUp ? 'Sign Up' : 'Sign In'}</h2>
        
        {error && <div className="auth-form-error">{error}</div>}
        {message && <div className="auth-form-message">{message}</div>}
        
        <div className="auth-form-group">
          <input
            type="email"
            placeholder="Email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="auth-form-input"
          />
        </div>
        
        <div className="auth-form-group">
          <input
            type="password"
            placeholder="Password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            className="auth-form-input"
          />
        </div>
        
        <button 
          type="submit" 
          disabled={loading}
          className="auth-form-button"
        >
          {loading ? 'Loading...' : (isSignUp ? 'Sign Up' : 'Sign In')}
        </button>
        
        <div className="auth-form-links">
          <button
            type="button"
            onClick={() => setIsSignUp(!isSignUp)}
            className="auth-form-link"
          >
            {isSignUp ? 'Already have an account? Sign In' : "Don't have an account? Sign Up"}
          </button>
          
          {!isSignUp && (
            <button
              type="button"
              onClick={handlePasswordReset}
              className="auth-form-link"
              disabled={loading}
            >
              Forgot Password?
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default AuthForm; 